import { render, staticRenderFns } from "./falvzhuanjia.vue?vue&type=template&id=144e9a28&scoped=true"
import script from "./falvzhuanjia.vue?vue&type=script&lang=js"
export * from "./falvzhuanjia.vue?vue&type=script&lang=js"
import style0 from "./falvzhuanjia.vue?vue&type=style&index=0&id=144e9a28&prod&scoped=true&lang=less"
import style1 from "./falvzhuanjia.vue?vue&type=style&index=1&id=144e9a28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e9a28",
  null
  
)

export default component.exports